module.exports = __webpack_public_path__ + "static/questions-6a1201796b62f58ec353585804507b09.svg";